"use client"

import { useEffect, useState } from "react"
import { createClient } from "@/utils/supabase/client"

const listingIdIsUuid = (value: string) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)

export function useListingSellerBanned(listingId: string | undefined | null, viewerId: string | null | undefined) {
  const [sellerBanned, setSellerBanned] = useState(false)

  useEffect(() => {
    const id = listingId && listingIdIsUuid(listingId) ? listingId : null
    if (!id) {
      setSellerBanned(false)
      return
    }
    const viewerUuid = viewerId && listingIdIsUuid(viewerId) ? viewerId : null
    let active = true
    const supabase = createClient()
    ;(async () => {
      const { data, error } = await supabase.rpc("get_listing_detail_view_model", {
        p_listing_id: id,
        p_viewer_id: viewerUuid,
      })
      if (!active) return
      if (error) {
        setSellerBanned(false)
        return
      }
      if (!data || typeof data !== "object") {
        setSellerBanned(false)
        return
      }
      const row = data as { error?: string; seller?: { banned_at?: string | null } | null }
      if (row.error) {
        setSellerBanned(false)
        return
      }
      setSellerBanned(Boolean(row.seller?.banned_at))
    })()
    return () => {
      active = false
    }
  }, [listingId, viewerId])

  return sellerBanned
}
